function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(.046 -1131.66) scale(1.1281)"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(1.197 0 0 1.1948 -5.56 -198.72)",
  x: 14.027,
  y: 1011.4,
  width: 20.947,
  height: 16.947,
  rx: 3.138,
  ry: 3.143,
  fill: "none",
  strokeLinejoin: "round",
  strokeWidth: 0.741
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.886
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.197 0 0 1.1948 -5.597 -198.72)",
  d: "M14 1021.7c2.99 4.676 17.99 4.676 21 0",
  fill: "none",
  strokeWidth: 0.741
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 0.811
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.197 0 0 .99921 -5.726 .588)",
  d: "M19.106 1018.6v-1.24M30.106 1018.6v-1.24"
})), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.197 0 0 1.1935 -5.597 -197.82)",
  d: "M20.5 1011.7v-3.004",
  fill: "none",
  strokeWidth: 0.742
}), /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(.59848 0 0 .59739 6.372 1003.7)",
  cx: 21,
  cy: 3,
  r: 1,
  strokeLinejoin: "round",
  strokeWidth: 1.482
}), /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(.59848 0 0 .59739 15.948 1003.7)",
  cx: 21,
  cy: 3,
  r: 1,
  strokeLinejoin: "round",
  strokeWidth: 1.482
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.197 0 0 1.1935 3.978 -197.82)",
  d: "M20.5 1011.7v-3.004",
  fill: "none",
  strokeWidth: 0.742
}))), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round",
  strokeWidth: 0.741,
  transform: "translate(.05 -1131.66) scale(1.1281)"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(1.197 0 0 1.1948 -5.597 -198.72)",
  x: 15.987,
  y: 1028.3,
  width: 17.026,
  height: 12.026,
  rx: 1.484,
  ry: 1.487
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-1.7207 0 0 1.711 52.83 977.641)",
  d: "M20 39a1 1 0 01-2 0h2z",
  strokeWidth: 0.517
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-1.2736 0 0 1.1557 44.957 1000.02)",
  d: "M20.603 39.286v3.179h-2.232v-3.179",
  strokeWidth: 0.731
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.19693 0 0 1.38238 -3.202 990.33)",
  d: "M17.567 42.484l3.438-.02v2.054h-5.022v-.643c0-.568.446-1.352 1.584-1.39z",
  strokeWidth: 0.689
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.7207 0 0 1.711 -5.389 977.641)",
  d: "M20 39a1 1 0 01-2 0h2z",
  strokeWidth: 0.517
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.2736 0 0 1.1557 2.485 1000.02)",
  d: "M20.603 39.286v3.179h-2.232v-3.179",
  strokeWidth: 0.731
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-1.19693 0 0 1.38238 50.643 990.33)",
  d: "M17.567 42.484l3.438-.02v2.054h-5.022v-.643c0-.568.446-1.352 1.584-1.39z",
  strokeWidth: 0.689
})), /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(-1.197 0 0 1.1948 53.546 1001.5)",
  cx: 24.911,
  cy: 29.429,
  r: 2.143
})), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.46
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.3503 0 0 3.5056 -6.41 -3530.79)",
  d: "M19.106 1018.6v-1.24M30.106 1018.6v-1.24"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 0.741
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.3503 0 0 1.3479 -6.306 -1355.836)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.063 1028.3h5.999m-2.125 2h-3.874",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(.5 0 0 .5 7 1016.3)",
  cx: 10,
  cy: 26,
  r: 2,
  strokeLinejoin: "round",
  strokeWidth: 1.482
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1 0 0 2.5766 -8.438 -1568.5)",
  d: "M20.438 1012.1v-3.493",
  strokeWidth: 0.462
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1 0 0 1.047 1 1003.1)",
  d: "M10 36.5c0-2.5 2-2.5 2 0",
  strokeLinejoin: "round",
  strokeWidth: 0.724
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1.3503 0 0 1.3479 59.944 -1355.836)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.063 1028.3h5.999m-2.125 2h-3.874",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(.5 0 0 .5 7 1016.3)",
  cx: 10,
  cy: 26,
  r: 2,
  strokeLinejoin: "round",
  strokeWidth: 1.482
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1 0 0 2.5766 -8.438 -1568.5)",
  d: "M20.438 1012.1v-3.493",
  strokeWidth: 0.462
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1 0 0 1.047 1 1003.1)",
  d: "M10 36.5c0-2.5 2-2.5 2 0",
  strokeLinejoin: "round",
  strokeWidth: 0.724
}))));

var SvgRobot = function SvgRobot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRobot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Robot.c47d8983.svg";
export { ForwardRef as ReactComponent };